import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=4e45eaa1&scoped=true&"
import script from "./NewPassword.vue?vue&type=script&lang=ts&"
export * from "./NewPassword.vue?vue&type=script&lang=ts&"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=4e45eaa1&scoped=true&lang=css&"
import style1 from "./NewPassword.vue?vue&type=style&index=1&id=4e45eaa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45eaa1",
  null
  
)

export default component.exports